<template>
  <div class="training_table">
    <div class="padding">
      <div class="return_box">
        <el-button @click="back">返回</el-button>
        <p>操作考核监控 > 评分管理 > {{ isText() }}</p>
      </div>
    </div>
    <main>
      <div class="main_top">
        <!-- 标题 -->
        <h3>考核名称:{{ row.Title }}</h3>
        <div class="hader_box">
          <p>
            考核时间：{{ $moment(row.BeginTime).format("YYYY/MM/DD HH:mm") }}-{{
              $moment(row.EndTime).format("YYYY/MM/DD HH:mm")
            }}
          </p>
          <p>考核内容：{{ row.ContentTxt }}</p>
        </div>
        <!-- 卡片区域 -->
        <ul class="card_box" v-if="state == 0">
          <li v-for="(item, index) in getCardList" :key="index">
            <div :class="index == getCardList.length - 1 ? 'border_none' : ''">
              <p>{{ item.title }}</p>
              <p>
                <span>{{ item.num }}</span
                >{{
                  item.title.charAt(item.title.length - 1) == "数" ? "人" : "分"
                }}
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 主体部分 -->
      <div v-if="state == 0">
        <!-- 查询条件 -->
        <div class="waitingcom_title">
          <el-form
            label-width="80px"
            :model="formLabelAlign"
            ref="formLabelAlign"
            :label-position="labelPosition"
          >
            <el-form-item label="考生姓名：" prop="scoreName">
              <el-input
                v-model.trim="formLabelAlign.scoreName"
                placeholder="请输入考生姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="科室：" prop="department">
              <el-select
                v-model.trim="formLabelAlign.department"
                label="全部"
                @change="searchChang"
              >
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="(item, index) in departmentArr"
                  :key="index"
                  :label="item.DepartmentName"
                  :value="item.DepartmentName"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="评分状态：" prop="scoreState">
              <el-select
                v-model.trim="formLabelAlign.scoreState"
                label="全部"
                @change="searchChang"
              >
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="item in scoreStateArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作分数：" prop="operationScore">
              <el-select
                v-model.trim="formLabelAlign.operationScore"
                label="全部"
                @change="searchChang"
              >
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="item in operationScoreArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发布状态：" prop="releaseState">
              <el-select
                v-model.trim="formLabelAlign.releaseState"
                label="全部"
                @change="searchChang"
              >
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="item in releaseStateArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="query_btn">
            <el-button
              type="primary"
              icon="el-icon-search"
              class="searchbtn"
              :loading="sundflag"
              @click="searchData()"
              >搜索</el-button
            >
            <el-button
              icon="el-icon-refresh"
              class="searchbtn sonbtn"
              @click.prevent.stop="resetForm('formLabelAlign')"
              >重置</el-button
            >
          </div>
        </div>
        <!-- 表格 -->
        <div class="oper_box">
          <el-button @click="fun2('total')"> 一键发布成绩</el-button>
          <el-button @click="exportListClick()"> 导出成绩列表</el-button>
          <el-button @click="fun4('batch')"> 批量导出考核表</el-button>
        </div>
        <div class="table">
          <Table
            ref="table"
            :tableObj="tableObj"
            :stateColor="stateColor"
            @row="getRow"
            :fun1="fun1"
            :fun2="fun2"
            :fun3="fun3"
            :fun4="fun4"
            :disabledFun="disabledFun"
            :buttonGrey="buttonGrey"
            :getDatalist="getDatalist"
            :buttonShowClick="buttonShowClick"
            :pageIndexs="pageIndexs"
            :eachPageNums="eachPageNums"
          />
          <div class="foot_box">
            <div class="foot_pagetions">
              <p></p>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pageIndexs"
                :page-size="eachPageNums"
                :page-sizes="pagesizesarr"
                layout="prev, pager, next,sizes, jumper"
                :total="total"
                class="pagination"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <EditorForm
        ref="editor"
        v-else-if="state == 1 || state == 2"
        :state="state"
        :operationObj="operationObj"
        :studentID="studentID"
        :Level="Level"
      />
      <!--  提示弹窗 -->
      <ComPopup
        :prompt="prompt"
        ref="ComPopup"
        :release="release"
        :exportAsse="exportAsse"
        :fun2="exportList"
        :text="text"
        :getTotal="getTotal"
      />
    </main>
  </div>
</template>

<script>
import { cardList, monitoringlist } from "@/state/operation";
import { hybrid } from "@/mixin/mixin";
import Table from "@/components/progress/Table.vue";
import EditorForm from "./EditorForm.vue";
import assessApi from "@/api/assessment";
import getstudentlist from "@/api/questionbank";
import ComPopup from "@/components/ComPopup.vue";
import loginvuex from "@/store/index";

export default {
  data() {
    return {
      getCardList: [],
      formLabelAlign: {
        scoreName: "", // 培训名称
        department: "", // 科室
        scoreState: "", // 评分状态
        operationScore: "", // 操作分数
        releaseState: "", // 发布状态
      },
      getDataCondition: {
        scoreName: "", // 培训名称
      },
      departmentArr: [],
      scoreStateArr: [
        {
          label: "未评分",
          value: "0",
        },
        {
          label: "已评分",
          value: "1",
        },
      ],
      operationScoreArr: [
        {
          label: "升序",
          value: "1",
        },
        {
          label: "降序",
          value: "0",
        },
      ],
      releaseStateArr: [
        {
          label: "未发布",
          value: "0",
        },
        {
          label: "已发布",
          value: "1",
        },
      ],
      // 配置表格
      tableObj: {
        selection: "no", // 是否需要多选
        buttonShow: false, // 是否有添加按钮
        getData: [
          {
            name: "蔡徐坤",
            type: "已评分",
            release1: "已发布",
            time: "2022/05/05 14:00",
          },
          {
            name: "鸡你太美",
            type: "未评分",
            release1: "未发布",
            time: "-",
          },
        ], // 列表数据
        formColumns: [], // 表头
        loading: true,
        qrShow: false, // 是否需要二维码
        tooltipShow: false,
        columnWidth: "398", // 操作按钮宽度
        buttonArr: [
          {
            name: "操作评分",
          },
          {
            name: "发布成绩",
          },
          {
            name: "查看评分详情",
          },
          {
            name: "导出考核表",
          },
        ],
      },
      rowObj: {}, // 获取当前行的信息
      state: 0, // 0展示表格 1展示操作评分 2查看评分详情
      dataObj: {},
      pageIndexs: 1, // 起始页
      eachPageNums: 10, // mixin定义的获取渲染分页序号有误
      operationObj: {},
      studentID: "", // 当前考生的ID
      prompt: {
        title: "发布成绩",
        info: "当前操作将发布考试成绩是否继续？",
        type: "",
      }, // 提示弹窗
      sundflag: false, // 防抖
      row: {}, // 列表当前行的信息
      text: "",
      flang: 0,
      text1: "", // 导航标签
      Level: "", // 表格的层级
    };
  },
  mixins: [hybrid], // 引入共用方法
  components: {
    Table,
    EditorForm,
    ComPopup,
  },
  methods: {
    back() {
      if (this.$route.query.state == "czpf" && this.state == 0) {
        // 操作评分返回
        this.$router.push({
          path: "/training/monitoring/situation", //跳转的路径
          query: {
            trainID: this.$route.query.trainID,
          },
        });
      } else {
        if (this.state == 0) {
          // this.$router.go(-1);
          this.$router.push({
            path: "/operationScore", //跳转的路径
          });
          this.$storage.sessionRemove("rowObj");
          this.$destroy();
        } else if (this.state == 1 || this.state == 2) {
          this.state = 0;
        }
      }
    },
    // chang查询
    searchChang() {
      this.tableObj.loading = true;
      this.getDatalist();
    },
    // 搜索
    searchData() {
      if (this.formLabelAlign.scoreName) {
        this.getDataCondition.scoreName = this.formLabelAlign.scoreName;
      } else {
        this.getDataCondition.scoreName = "";
      }
      this.tableObj.loading = true;
      this.getDatalist();
    },
    // 重置
    resetForm() {
      this.examTime = "";
      this.resetFun(this.formLabelAlign, this.getDataCondition);
    },
    // 导出评分详情
    exportDetails() {},
    exportListClick() {
      this.prompt.title = "温馨提示";
      this.prompt.info = "当前操作将导出成绩列表，是否继续？";
      this.prompt.type = "";
      this.$refs.ComPopup.dialogVisibleObj.export = true;
    },
    // 导出成绩列表
    exportList() {
      let obj = {
        examineID: this.$route.query.ID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      this.$refs.ComPopup.sundflag = true;
      assessApi.exportXls_down(obj).then((res) => {
        console.log(res, "??");
        if (res.data.Status == 200) {
          let link = document.createElement("a");
          // let url = `${process.env.VUE_APP_EXPORTURL}${res.data.Data}`;
          let url = res.data.Data;
          link.setAttribute("target", "_blank");
          link.href = url;
          link.click();
          this.$message({
            message: `恭喜你，考核名称为${this.row.Title}导出成绩列表成功`,
            type: "success",
          });
          setTimeout(() => {
            this.$refs.ComPopup.sundflag = false;
          }, 500);
          this.$refs.ComPopup.dialogVisibleObj.export = false;
        } else {
          this.$refs.ComPopup.sundflag = false;
          this.$message.error(data.message);
        }
      });
    },
    // 获取当前行
    getRow(row) {
      this.rowObj = row;
    },
    // 操作评分
    fun1() {
      this.state = 1;
      this.studentID = this.rowObj.row.UserID;
      this.scoreDetails(); // 获取操作评分列表
    },
    // 发布成绩
    fun2(text) {
      if (text == "total") {
        this.prompt.type = "plfb"; // 批量
        this.prompt.title = "一键发布成绩";
        this.prompt.info = "当前操作将一键发布(已评分考生)考试成绩是否继续？";
      } else {
        this.prompt.type = "fb";
      }
      this.$refs.ComPopup.dialogVisibleObj.export = true;
    },
    // 发布成绩执行
    async release() {
      let obj = {
        examineID: this.$route.query.ID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      if (this.prompt.type == "fb") {
        obj.studentID = this.rowObj.row.UserID;
      }
      this.$refs.ComPopup.sundflag = true;
      const { data } = await assessApi.exportPublish(obj);
      if (data.Status == 200) {
        let text1 =
          this.prompt.type == "plfb"
            ? `考核名称${this.rowObj.Title}一键发布成绩成功！`
            : `考生名为${this.rowObj.row.RealName}发布成绩成功`;
        this.$message({
          message: `恭喜你，${text1}`,
          type: "success",
        });
        setTimeout(() => {
          this.$refs.ComPopup.sundflag = false;
        }, 500);
        this.getDatalist();
        this.getTotal(); // 更新卡列表
      } else {
        this.$refs.ComPopup.sundflag = false;
        this.$message.error(data.Msg);
      }
    },
    // 查看评分详情
    fun3() {
      this.text = this.rowObj.row.IsPublish1;
      this.state = 2; // 编辑
      this.studentID = this.rowObj.row.UserID;
      this.scoreDetails(); // 获取操作评分列表
    },
    // 导出单个考生考核表
    fun4(type) {
      if (type == "batch") {
        this.prompt.type = "pldc"; // 批量
        this.prompt.title = "批量导出考核表";
        this.prompt.info = "当前操作将导出所有考生考核表，是否继续？";
      } else {
        this.prompt.type = "dc"; // 批量
        this.prompt.title = "导出考核表";
        this.prompt.info = "当前操作将导出考核表，是否继续？";
      }
      this.$refs.ComPopup.dialogVisibleObj.export = true;
    },
    // 导出或批量考核表
    exportAsse() {
      // 此处是导出word文档,拼接域名
      let obj = {
        examineID: this.$route.query.ID,
        type: 0,
        studentID: "",
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      if (this.prompt.type == "dc") {
        obj.studentID = this.rowObj.row.UserID; // 单个考生考核表
      }
      this.$refs.ComPopup.sundflag = true;
      assessApi.word_down(obj).then((res) => {
        if (res.data.Status == 200) {
          let link = document.createElement("a");
          // let url = `${process.env.VUE_APP_EXPORTURL}${res.data.Data}`;
          let url = res.data.Data;
          link.setAttribute("target", "_blank");
          link.href = url;
          link.click();
          this.$message({
            message: `恭喜你，考核名称为${this.row.Title}导出考核表成功`,
            type: "success",
          });
          setTimeout(() => {
            this.$refs.ComPopup.sundflag = false;
          }, 500);
          this.$refs.ComPopup.dialogVisibleObj.export = false;
        } else {
          this.$refs.ComPopup.sundflag = false;
          this.$message.error(data.message);
        }
      });
    },
    // 是否禁用
    disabledFun(row, item) {
      // row 当前行的信息  item ===> 指定禁用那个按钮
      // 已发布成绩的情况下就不能再操作评分了
      if (row.IsPublish1 == "已发布" && item.name == "操作评分") {
        return true;
      } else if (
        row.IsScore1 == "未评分" &&
        (item.name == "发布成绩" || item.name == "查看评分详情")
      ) {
        return true;
      } else {
        return false;
      }
    },
    // 是否置灰
    buttonGrey(row, item, index, lengths) {
      if (index == lengths - 1) {
        return "border_none";
      } else if (row.IsPublish1 == "已发布" && item.name == "发布成绩") {
        return "grey";
      } else {
        return "";
      }
    },
    // 是否有按钮
    buttonShowClick(row, item) {
      if (row.IsPublish1 == "未发布" && item.name == "导出考核表") {
        // 已发布的情况下，才有导出考核表按钮
        return false;
      } else {
        return true;
      }
    },
    // 表格样式设置
    stateColor({ row, column, rowIndex, columnIndex }) {
      if (row.type === "待考核" && columnIndex === 4) {
        return "gray";
      } else if (row.type === "考核中" && columnIndex === 4) {
        return "blue";
      } else if (row.type === "考核结束" && columnIndex === 4) {
        return "red";
      }
    },
    // 获取统计数据 卡片
    async getTotal() {
      let obj = {
        examineID: this.$route.query.ID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await assessApi.scoreTotal(obj);
      if (data.Status == 200) {
        this.dataObj = JSON.parse(JSON.stringify(data.Data[0]));
        this.row = data.Data[0];
        for (let i in this.dataObj) {
          this.getCardList.forEach((item) => {
            if (item.type == i) {
              item.num = this.dataObj[i];
            }
          });
        }
        this.getCardList[4].num =
          this.dataObj.ApplyUser - this.dataObj.PassUser;
        // 已考人数 ApplyUser 减 及格人数 == 不及格人数
      } else {
        this.$message.error(data.Msg);
      }
    },
    // 获取列表
    async getDatalist() {
      let obj = {
        userName: this.getDataCondition.scoreName, // 用户名
        examineID: this.$route.query.ID, // ID
        departmentName: this.formLabelAlign.department, // 部门ID
        isScore: this.formLabelAlign.scoreState, // 是否评分 0未评分 1已评分
        isPublish: this.formLabelAlign.releaseState, // 发布状态 0未发布 1已发布
        scoreSorting: this.formLabelAlign.operationScore, // 分数 降序 0 升序 1
        pageIndex: this.pageIndexs, //当前页
        pageSize: this.eachPageNums, // 一页多少条
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      this.sundflag = true;
      const { data } = await assessApi.getExamineelist(obj);
      if (data.Status == 200) {
        this.tableObj.getData = data.Data.list.map((item) => {
          this.$set(item, "IsScore1", item.IsScore == 0 ? "未评分" : "已评分");
          this.$set(
            item,
            "IsPublish1",
            item.IsPublish == 0 ? "未发布" : "已发布"
          );
          this.$set(
            item,
            "ApplyTime1",
            item.ApplyTime == null
              ? "-"
              : this.$moment(item.ApplyTime).format("YYYY-MM-DD HH:mm:ss")
          );
          if (item.Score == -1) {
            item.Score = "-";
          }
          if (item.Teacher == null) {
            item.Teacher = "-";
          }
          if (item.ApplyTime == null) {
            item.ApplyTime = "-";
          }
          return item;
        });
        this.total = data.Data.dataCount;
        setTimeout(() => {
          this.tableObj.loading = false;
          this.sundflag = false;
        }, 500);
      } else {
        this.sundflag = false;
        this.$message.error(data.Msg);
      }
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      // this.loading = true;
      this.eachPageNums = val;
      this.getDatalist();
    },
    handleCurrentChange(val) {
      this.pageIndexs = val;
      console.log(`当前页: ${this.pageIndexs}`);
      // this.loading = true;
      this.getDatalist();
    },
    // 获取科室查询
    async getDepartment() {
      let obj = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await getstudentlist.getseekAndCreateExam(obj);
      if (data.Status == 200) {
        this.departmentArr = data.Data[1];
      }
    },
    // 获取操作评分弹窗
    async scoreDetails() {
      let obj = {
        examineID: this.$route.query.ID,
        studentID: this.rowObj.row.UserID, // 考生ID
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await assessApi.scoreDetails(obj);
      if (data.Status == 200) {
        // 改数组是已评分的渲染
        this.operationObj = data.Data[0];
        this.$refs.editor.passScore = data.Data[0].PassScore; // 及格分
        this.Level = data.Data[0].Level; // 表格层级
        //如果ContentTxt  有值 就用它  没有就用ScoreContentTxt
        if (JSON.parse(this.operationObj.ContentTxt) != null) {
          let arr = JSON.parse(this.operationObj.ContentTxt)[0].list;
          this.$refs.editor.tableData = this.dealWithData(
            arr,
            this.Level,
            true
          ); // 数据处理
          let row = JSON.parse(this.operationObj.ContentTxt)[0].info;
          console.log(row);
          this.$refs.editor.ruleForm.name = row.item; // 名称
          this.$refs.editor.operationObj.ScoreTitle = row.ScoreTitle; // 操作评分表名称
          this.$refs.editor.ruleForm.time = row.createTime; // 时间
        } else {
          // 该数组是未评分渲染
          this.$refs.editor.ruleForm.time = this.$moment().format(
            "YYYY-MM-DD HH:mm:ss"
          );
          let arr = JSON.parse(this.operationObj.ScoreContentTxt);
          this.$refs.editor.tableData = this.dealWithData(
            arr,
            this.Level,
            false
          ); // 数据处理
          // let row = JSON.parse(this.operationObj.ContentTxt)[0].info;
          this.$refs.editor.ruleForm.name = this.operationObj.Title; // 名称  3.3产品修改为ScoreTitle==》Title
          console.log(this.operationObj.ScoreTitle);

          // this.$refs.editor.tableData = JSON.parse(
          //   this.operationObj.ScoreContentTxt
          // );
        }
        // this.$refs.editor.tableData = this.operationObj.ContentTxt // 列表渲染
      } else {
        this.$message.error(data.Msg);
      }
    },
    // 对三层列表的数据处理
    dealWithData(arr, type, whether) {
      let newarr = [];
      if (type == 1 && whether == true) {
        newarr = arr.map((item) => {
          item.scoreTxte = item.scoreTxte != "" ? item.scoreTxte : ""; // 扣分细节
          item.score = Number(item.score); // 得分
          item.projectScore = Number(item.projectScore); // 项目分
          item.minScore = 0; // 最小值
          item.totalScores = this.row.TotalScore; // 总分
          return item;
        });
      }
      if (type == 1 && whether == false) {
        newarr = arr.map((item) => {
          item.scoreTxte = "";
          // 未评分状态score默认满分
          item.score = item.projectScore;
          item.projectScore = Number(item.projectScore);
          item.minScore = 0; // 最小值
          item.totalScores = this.row.TotalScore; // 总分
          return item;
        });
      } else if (type == 2 && whether == true) {
        newarr = arr.map((item) => {
          item.child.map((zitem) => {
            // zitem.userValue = zitem.userValue == "无" ? 0 : zitem.userValue;
            zitem.minScore = 0;
            zitem.totalScores = this.row.TotalScore; // 总分
            return zitem;
          });
          return item;
        });
      } else if (type == 2 && whether == false) {
        newarr = arr.map((item) => {
          item.child.map((zitem) => {
            if(!zitem.scoreValue){
                this.$set(zitem, "scoreValue", -1); // 用户在创建的时候输入空格导致没，这里创建一个
              }
             if (zitem.scoreValue < 0 || zitem.scoreValue == "(扣分项)" || zitem.scoreValue == "无") {
              this.$set(zitem, "userValue", 0);
            } else {
              this.$set(zitem, "userValue", Number(zitem.scoreValue));
            }
            this.$set(zitem, "userTxte", "");
            this.$set(zitem, "minScore", 0);
            this.$set(zitem, "totalScores", this.row.TotalScore);
            return zitem;
          });
          return item;
        });
      } else if (type == 3 && whether == true) {
        newarr = arr.map((item) => {
          item.child.map((zitem) => {
            zitem.child.map((sitem) => {
              sitem.minScore = 0;
              sitem.totalScores = this.row.TotalScore; // 总分
            });
          });
          return item;
        });
      } else if (type == 3 && whether == false) {
        arr.forEach((item) => {
          item.projectScore = Number(item.projectScore);
          this.$set(item, "score", Number(item.projectScore)); // 得分
          item.child.forEach((zitem) => {
            zitem.child.forEach((sitem) => {
               if(!sitem.scoreValue){
                this.$set(sitem, "scoreValue", -1); // 用户在创建的时候输入空格导致没，这里创建一个
              }
               if (sitem.scoreValue < 0 || sitem.scoreValue == "(扣分项)" || sitem.scoreValue == "无") {
                this.$set(sitem, "userValue", 0);
              } else {
                this.$set(sitem, "userValue", sitem.scoreValue);
              }
              this.$set(zitem, "minScore", 0);
              this.$set(zitem, "totalScores", this.row.TotalScore);
              this.$set(sitem, "userTxte", "");
            });
          });
        });
        newarr = arr;
      }
      return newarr;
    },
  },
  computed: {
    isText() {
      return function () {
        if (this.state == 0) {
          // 如果当前培训是今天小球变成红色
          return "";
        } else if (this.state == 1) {
          return "操作评分";
        } else if (this.state == 2) {
          return "查看评分详情";
        }
      };
    },
  },
  created() {
    this.getCardList = cardList; // 卡片
    this.tableObj.formColumns = monitoringlist; // 表头
    this.getTotal();
    this.getDatalist();
    this.getDepartment(); // 获取科室
  },
};
</script>

<style lang="scss" scoped>
.training_table {
  height: 100%;
  width: 100%;
  background: #fff;
  min-height: 740px;
}
.padding {
  padding: 30px 36px 0px 36px;
  // margin-bottom: 30px;
}
.return_box {
  display: flex;
  align-items: center;
  margin-bottom: 45px;
  .el-button {
    // width: 56px;
    height: 40px;
    background: #f6f6f6;
    border: 1px solid #dfdfdf;
    border-radius: 2px;
    margin-right: 30px;
  }
}
main {
  .main_top {
    padding: 0px 36px;
  }
  h3 {
    margin-bottom: 22px;
  }
  .hader_box {
    color: #999999;
    display: flex;
    align-items: center;
    p {
      &:nth-child(1) {
        margin-right: 70px;
      }
    }
  }
  .card_box {
    display: flex;
    align-items: center;
    margin-top: 16px;
    li {
      width: 200px;
      height: 116px;
      background: #f4f5f7;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      div {
        border-right: 1px solid #cccccc;
        width: 100%;
        p {
          text-align: center;
          &:nth-child(1) {
            margin-bottom: 24px;
            color: #999999;
          }
          &:nth-child(2) {
            color: #333333;
            span {
              font-size: 24px;
              margin-right: 4px;
            }
          }
        }
      }
    }
  }
}
.border_none {
  border-right: none !important;
}
.waitingcom_title {
  margin-top: 65px;
  height: 90px;
  padding: 24px 36px 16px 20px;
  border-bottom: 1px solid #dbdee2;
  display: flex;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  ::v-deep .el-form-item__content {
    margin-left: 115px !important;
  }
  .el-form {
    display: flex;
  }
}
.hos_table {
  min-height: 560px;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
  padding-left: 0px;
  padding-right: 0px;
}
.sonbtn {
  border: 1px solid #d9d9d9 !important;
  color: #999999;
}
.query_btn {
  margin: 0;
  display: flex;
  .el-button {
    width: 88px;
    height: 40px;
    margin-left: 24px;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
::v-deep .el-table .red .cell {
  color: #ff0000 !important;
}
::v-deep .el-table .gray .cell {
  color: #999999 !important;
}
::v-deep .el-table .blue .cell {
  color: #0084ea !important;
}
.oper_box {
  display: flex;
  align-items: center;
  margin-left: 36px;
  margin-top: 26px;
  .el-button {
    color: #fff;
    background: #0084ea;
  }
}
.table {
  padding-left: 12px;
}
// 分页
.foot_box {
  position: relative;
  height: 140px;
  ::v-deep .el-pager li:hover {
    color: #0084ea;
  }
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #0084ea;
        border: none;
      }
    }
  }
}
</style>
